import { render } from "./CapsulaFill.vue?vue&type=template&id=3a8e8fd9&scoped=true"
import script from "./CapsulaFill.vue?vue&type=script&lang=js"
export * from "./CapsulaFill.vue?vue&type=script&lang=js"

import "./CapsulaFill.vue?vue&type=style&index=0&id=3a8e8fd9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8e8fd9"]])

export default __exports__